import { render } from "./TicketItems.vue?vue&type=template&id=38c11cc2&ts=true"
import script from "./TicketItems.vue?vue&type=script&lang=ts"
export * from "./TicketItems.vue?vue&type=script&lang=ts"

import "./TicketItems.vue?vue&type=style&index=0&id=38c11cc2&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__